import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as l, normalizeClass as o, createElementVNode as a } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCpu",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], u = ["clip-path"], _ = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5.5A.5.5 0 0 1 5 1v.5h2V1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 10.5 3v1h.5a.5.5 0 0 1 0 1h-.5v1.5h.5a.5.5 0 0 1 0 1h-.5V9A1.5 1.5 0 0 1 9 10.5H8v.5a.5.5 0 0 1-1 0v-.5H5v.5a.5.5 0 0 1-1 0v-.5H3A1.5 1.5 0 0 1 1.5 9V7.5H1a.5.5 0 0 1 0-1h.5V5H1a.5.5 0 0 1 0-1h.5V3A1.5 1.5 0 0 1 3 1.5h1V1a.5.5 0 0 1 .5-.5ZM3 2.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3Zm1 2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3ZM5 5v2h2V5H5Z",
  fill: "currentColor"
}, null, -1), p = [
  _
], f = ["id"], m = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), v = [
  m
];
function g(e, H, d, I, V, t) {
  return l(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([t.iconSizeClass, "d-icon d-icon--cpu"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Cpu",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, p, 8, u),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, f)
    ])
  ], 10, h);
}
const S = /* @__PURE__ */ s(c, [["render", g]]);
export {
  S as default
};
//# sourceMappingURL=cpu.js.map
